module.exports = __webpack_public_path__ + "files/5eeae2ad42a4a9116545c83244d5c140.png";